import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';
import { UserLoginResponse } from 'app/shared/models/user-login-response.model';
import { UserLogin } from 'app/shared/models/user-login.model';
import { UserTwoFactorLogin } from 'app/shared/models/user-twofactor-login.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  submitInProgress: boolean = false
  userLogin: UserLogin;
  protected loginMessage: string;

  constructor(private authenticationService: AuthenticationService, private router: Router, protected translateService: TranslateService) {
  }

  ngOnInit() {
    this.initializeObject();
    this.translateService.get(['account.login.loginMessage'])
      .subscribe(translations => {
        this.loginMessage = translations['account.login.loginMessage'];
      });
  }

  initializeObject() {
    if (this.userLogin == null) {
      this.userLogin = new UserLogin();
    }
  }

  onSubmit(form: NgForm) {
    if (!this.submitInProgress) {
      this.submitInProgress = true;
      this.authenticationService.login(form.value, (userLoginResponse: UserLoginResponse) => this.handleTwoFactorLogin(userLoginResponse), () => this.submitInProgress = false);
    }
  }

  handleTwoFactorLogin(userLoginResponse: UserLoginResponse) {
    if ((userLoginResponse.TwoFactorEnabled) && (!userLoginResponse.TwoFactorSetupEnabled)) {
      this.router.navigate(['/account/two-factor-login'], {queryParams: {authenticationId: userLoginResponse.TwoFactorAuthenticationId}});
    } else {
      this.authenticationService.twoFactorLogin(new UserTwoFactorLogin(userLoginResponse.TwoFactorAuthenticationId, "", userLoginResponse.TwoFactorSetupEnabled), userLoginResponse.TwoFactorSetupEnabled,
        () => this.submitInProgress = false, this.loginMessage);
    }
  }
}
